import { Outlet } from 'react-router-dom';
import Navigation from '../Navigation/Navigation';
import Footer from '../Footer/Footer';
import styles from './Layout.module.css';

const Layout = () => {
  return (
    <div className={styles.layout} id="top">
      <a href="#main" className={styles.skip}>
        Skip to content
      </a>
      <Navigation />
      <main className={styles.main} id="main">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
